import PropTypes from 'prop-types';
import filterDefinitionPropType from './filterDefinitionPropType';

export default PropTypes.arrayOf(filterDefinitionPropType);
